import { useContext, useEffect } from 'react';
import { setAsyncConfirmation, syncDialogsWithURL } from 'store/Dialog';
import { LocalizationContext } from 'contexts';

export const DialogInitializer = () => {
  const { dictionary } = useContext(LocalizationContext);

  useEffect(() => {
    setAsyncConfirmation(dictionary);
  }, [dictionary]);

  useEffect(() => {
    return syncDialogsWithURL();
  }, []);

  return null;
};